// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { Options } from './Options.gen';
import type { PublicTariffProfileControllerCreateData } from './PublicTariffProfileControllerCreateData.gen';
import type { PublicTariffProfileControllerCreateErrors } from './PublicTariffProfileControllerCreateErrors.gen';
import type { PublicTariffProfileControllerCreateResponses } from './PublicTariffProfileControllerCreateResponses.gen';
import type { PublicTariffProfileControllerDeleteData } from './PublicTariffProfileControllerDeleteData.gen';
import type { PublicTariffProfileControllerDeleteErrors } from './PublicTariffProfileControllerDeleteErrors.gen';
import type { PublicTariffProfileControllerDeleteResponses } from './PublicTariffProfileControllerDeleteResponses.gen';
import type { PublicTariffProfileControllerGetAllData } from './PublicTariffProfileControllerGetAllData.gen';
import type { PublicTariffProfileControllerGetAllErrors } from './PublicTariffProfileControllerGetAllErrors.gen';
import type { PublicTariffProfileControllerGetAllResponses } from './PublicTariffProfileControllerGetAllResponses.gen';
import type { PublicTariffProfileControllerGetComputedValidityData } from './PublicTariffProfileControllerGetComputedValidityData.gen';
import type { PublicTariffProfileControllerGetComputedValidityErrors } from './PublicTariffProfileControllerGetComputedValidityErrors.gen';
import type { PublicTariffProfileControllerGetComputedValidityResponses } from './PublicTariffProfileControllerGetComputedValidityResponses.gen';
import type { PublicTariffProfileControllerGetOneData } from './PublicTariffProfileControllerGetOneData.gen';
import type { PublicTariffProfileControllerGetOneErrors } from './PublicTariffProfileControllerGetOneErrors.gen';
import type { PublicTariffProfileControllerGetOneResponses } from './PublicTariffProfileControllerGetOneResponses.gen';
import type { PublicTariffProfileControllerUpdateData } from './PublicTariffProfileControllerUpdateData.gen';
import type { PublicTariffProfileControllerUpdateErrors } from './PublicTariffProfileControllerUpdateErrors.gen';
import type { PublicTariffProfileControllerUpdateResponses } from './PublicTariffProfileControllerUpdateResponses.gen';

export class PublicTariffProfileController {
    /**
     * Get tariff profiles.
     *
     * Require: `PERMISSION_TARIFF-PROFILES_VIEW`
     */
    public static getAll<ThrowOnError extends boolean = false>(options?: Options<PublicTariffProfileControllerGetAllData, ThrowOnError>) {
        return (options?.client ?? client).get<PublicTariffProfileControllerGetAllResponses, PublicTariffProfileControllerGetAllErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/tariff-profiles',
            ...options
        });
    }
    
    /**
     * Create tariff profile.
     *
     * Require: `PERMISSION_TARIFF-PROFILES_EDIT`<br>
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **INVALID_VALID_TO** - ValidFrom is after ValidTo OR New ValidFrom is null or new validFrom is before old ValidFrom.<br>
     * + **INVALID_TARIFF_PROFILE_TYPE** - Tariff profile type does not exist or input data are not sufficient.<br>
     * + **INVALID_TARIFF_PROFILE_PERIOD** - Tariff profile period does not exist.<br>
     * + **INVALID_TARIFF_PROFILE** - Tariff profile does not exist.
     */
    public static create<ThrowOnError extends boolean = false>(options: Options<PublicTariffProfileControllerCreateData, ThrowOnError>) {
        return (options.client ?? client).post<PublicTariffProfileControllerCreateResponses, PublicTariffProfileControllerCreateErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/tariff-profiles',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete tariff profile.
     *
     * If an entity is being used, 409 Conflict will be returned.<br>
     * Require: `PERMISSION_TARIFF-PROFILES_DELETE`
     */
    public static delete<ThrowOnError extends boolean = false>(options: Options<PublicTariffProfileControllerDeleteData, ThrowOnError>) {
        return (options.client ?? client).delete<PublicTariffProfileControllerDeleteResponses, PublicTariffProfileControllerDeleteErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/tariff-profiles/{id}',
            ...options
        });
    }
    
    /**
     * Get tariff profile by id.
     *
     * Require: `PERMISSION_TARIFF-PROFILES_VIEW`
     */
    public static getOne<ThrowOnError extends boolean = false>(options: Options<PublicTariffProfileControllerGetOneData, ThrowOnError>) {
        return (options.client ?? client).get<PublicTariffProfileControllerGetOneResponses, PublicTariffProfileControllerGetOneErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/tariff-profiles/{id}',
            ...options
        });
    }
    
    /**
     * Update tariff profile names.
     *
     * Require: `PERMISSION_TARIFF-PROFILES_EDIT`<br>
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **INVALID_VALID_TO** - Valid to must be bigger than valid from or is in the past.
     */
    public static update<ThrowOnError extends boolean = false>(options: Options<PublicTariffProfileControllerUpdateData, ThrowOnError>) {
        return (options.client ?? client).put<PublicTariffProfileControllerUpdateResponses, PublicTariffProfileControllerUpdateErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/tariff-profiles/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get computed validity for the given tariff profile.
     */
    public static getComputedValidity<ThrowOnError extends boolean = false>(options: Options<PublicTariffProfileControllerGetComputedValidityData, ThrowOnError>) {
        return (options.client ?? client).get<PublicTariffProfileControllerGetComputedValidityResponses, PublicTariffProfileControllerGetComputedValidityErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/tariff-profiles/{id}/computed-validity',
            ...options
        });
    }
}
